import type { DocumentType } from '@/enums/DocumentType'
import type { PlanVersion } from '@/mixins/planVersionsV2'
import { useDocumentStore } from '@/stores/document'
import type { StoreDocument } from '@/types'

export const getPolicyPacketDocuments = () => {
	const documentStore = useDocumentStore()

	const gatherDocumentsForAppointment = async (plans: PlanVersion[]) => {
		const completedDocuments = await Promise.all(
			plans.map((planVersion) => getCompletedDocumentsForPlan(planVersion))
		)

		return completedDocuments.filter((documentList) => !!documentList.length)
	}

	const getCompletedDocumentsForPlan = async (
		plan: PlanVersion
	): Promise<StoreDocument[]> => {
		const documentsToPrint = plan.documents?.filter((document) =>
			shouldDocumentBeIncluded(document, plan)
		)
		if (!documentsToPrint) return []

		const documentIds = documentsToPrint.map((d) => d.id)

		return await documentStore.fetchDocumentsForPlanHolder(documentIds)
	}

	return {
		gatherDocumentsForAppointment,
	}
}

/**
 * 	Check if a document should be included for print.
 * 	Any special cases for exclusion can be handled here
 * 	e.g. everplans isn't in cart Everplans form should be taken out
 * @param document
 * @param plan
 */
export const shouldDocumentBeIncluded = (
	document: { id: string; type: DocumentType },
	plan: PlanVersion
) => {
	return plan.completedSteps?.includes(document.type)
}
